import { parseISO } from "date-fns";
import React from "react";

import { IBasket, IBasketLine } from "../../../models/catalogue.interfaces";
import { LinePriceType, getBasketLinePrice } from "../../../utils/catalogue";
import { BasketLineVariant } from "../constants";
import { BasketLineOfferDetails } from "./BasketLineOfferDetails";
import { LinePrice } from "./LinePrice";

export const BasketLinePrice = (props: {
    line: IBasketLine;
    basket: IBasket;
    isMinimal: boolean;
    variant?: BasketLineVariant;
}): React.ReactNode => {
    // Check if product has pricing disclaimer and is currently discounted
    const product = props.line.product;
    const pricingDisclaimer = product.pricing_disclaimer;
    const isDiscounted = getBasketLinePrice(props.basket, props.line, {
        priceType: LinePriceType.RETAIL,
    }).greaterThan(
        getBasketLinePrice(props.basket, props.line, {
            priceType: LinePriceType.EXCL_TAX_INCL_DISCOUNTS,
        }),
    );

    // Only show disclaimer in full basket view
    const isFullBasket = props.variant === BasketLineVariant.FULL;

    const lastFullPriceDate =
        pricingDisclaimer?.show_disclaimer &&
        isDiscounted &&
        pricingDisclaimer.last_full_price_date &&
        isFullBasket // Only show in full basket
            ? parseISO(pricingDisclaimer.last_full_price_date)
            : null;

    return (
        <LinePrice
            retailPrice={getBasketLinePrice(props.basket, props.line, {
                priceType: LinePriceType.RETAIL,
            })}
            linePriceInclDiscounts={getBasketLinePrice(
                props.basket,
                props.line,
                {
                    priceType: LinePriceType.EXCL_TAX_INCL_DISCOUNTS,
                },
            )}
            postDiscountAddons={props.line.product.price.post_discount_addons}
            quantity={props.line.quantity}
            lastFullPriceDate={lastFullPriceDate}
        >
            {!props.isMinimal && (
                <BasketLineOfferDetails
                    line={props.line}
                    basket={props.basket}
                />
            )}
        </LinePrice>
    );
};
